<template src="../templates/groupItem.html">

</template>

<script>
    import Config from "../config/config";

    export default {
        name: "GroupItem",
        props: {
            groupModel: {
                type: Object,
                required: true
            },
            availableAccessPoints: {
                type: Array,
                required: true
            },
            isAdmin: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                editGroupModel: {
                    clientAccessGroupId: "",
                    name: "",
                    isAdmin: false,
                    numericIdentifier: "",
                    active: true
                },
                editGroupVisible: false,
                groupPermissions: [],
                hasContacts: true,
                message: ""
            }
        },
        methods: {
            isEditable() {
                return this.isAdmin;
            },
            cancelEditGroup() {
                this.editGroupVisible = false;
            },
            showErrorMsg(errMsg) {
                this.$message.error(errMsg);
            },
            editGroup() {
                let self = this;
                let url = `${this.$localApiURL}group/addEditGroup`;
                this.$http.post(url, {
                    token: localStorage.getItem("jwt"),
                    group: this.editGroupModel,
                    permissions: this.groupPermissions
                }).then(res => {
                    let result = res.data;
                    self.$emit("groupUpdated");
                }).catch(function (error) {
                    console.log(error);
                });
                this.editGroupVisible = false;

            },
            loadEditDialog() {
                this.editGroupVisible = true;
            },
            getGroupPermissions() {
                let url = `${this.$localApiURL}group/getGroupPermissions/${this.groupModel.clientAccessGroupId}`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    let data = res.data;
                    if (data != null && data.length > 0) {
                        for (let item in data) {
                            self.groupPermissions.push(data[item].accessPointId);
                        }
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            checkGroupContacts() {
                let url = `${this.$localApiURL}group/hasContacts/${this.groupModel.clientAccessGroupId}`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    let data = res.data;
                    if (data.hasContacts === "true") {
                        self.$message.error("Group cannot be deleted because it has users assigned");
                    } else {
                        self.deleteGroup();
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            deleteGroup() {
                let self = this;
                let url = `${this.$localApiURL}group/delete`;
                this.$http.post(url, {
                    token: localStorage.getItem("jwt"),
                    clientGroupId: this.editGroupModel.clientAccessGroupId
                }).then(res => {
                    self.$emit("groupUpdated");
                }).catch(function (error) {
                    this.$message.error('Error deleting the group please contact the administrator');
                    console.log(error);
                });
            }
        }, created() {
            this.editGroupModel.clientAccessGroupId = this.groupModel.clientAccessGroupId;
            this.editGroupModel.name = this.groupModel.name;
            this.editGroupModel.isAdmin = this.groupModel.isAdmin === "1";
            this.editGroupModel.active = this.groupModel.active === "1";
            this.editGroupModel.itProjectId = Config.projectId;
            this.getGroupPermissions();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/GroupItem.vue